import { TemplateRef } from '@angular/core';
import { FlexibleColumn } from '@ip-only/front-end-library';
import {
  ColumnModification,
  ColumnModifications,
} from './installation-reporting.columns.utils';

const addressColumn: FlexibleColumn = {
  id: 'address',
  header: 'ordersOverview.tableHeaders.address',
  alignment: 'left',
};

const deliveryPoints: FlexibleColumn = {
  id: 'deliveryPoints',
  header: 'ordersOverview.tableHeaders.deliveryPoints',
  alignment: 'left',
};

const customerType: FlexibleColumn = {
  id: 'customerType',
  header: 'ordersOverview.tableHeaders.customerType',
  alignment: 'left',
};

const customerNameColumn: FlexibleColumn = {
  id: 'customerName',
  header: 'ordersOverview.tableHeaders.customerName',
  alignment: 'left',
};

const completedDateColumn: FlexibleColumn = {
  id: 'completedDate',
  header: 'ordersOverview.tableHeaders.completedDate',
  alignment: 'left',
};

const statusColumn: FlexibleColumn = {
  id: 'latestStatus',
  header: 'ordersOverview.tableHeaders.latestStatus',
  alignment: 'left',
};

const statusDateColumn: FlexibleColumn = {
  id: 'statusDate',
  header: 'ordersOverview.tableHeaders.statusDate',
  alignment: 'left',
};

const netAdminIdColumn: FlexibleColumn = {
  id: 'netAdminId',
  header: 'ordersOverview.tableHeaders.netAdminId',
  alignment: 'left',
};

const customerInstallationDateColumn: FlexibleColumn = {
  id: 'customerInstallationDate',
  header: 'ordersOverview.tableHeaders.customerInstallationDate',
  alignment: 'left',
};

const plotDesignDateColumn: FlexibleColumn = {
  id: 'plotDesignDate',
  header: 'ordersOverview.tableHeaders.plotDesignDate',
  alignment: 'left',
};

const preinstallationDateColumn: FlexibleColumn = {
  id: 'preinstallationDate',
  header: 'ordersOverview.tableHeaders.preinstallationDate',
  alignment: 'left',
};

const plotExcavationDateColumn: FlexibleColumn = {
  id: 'plotExcavationDate',
  header: 'ordersOverview.tableHeaders.plotExcavationDate',
  alignment: 'left',
};

const ductConnectionColumn: FlexibleColumn = {
  id: 'ductConnection',
  header: 'ordersOverview.tableHeaders.ductConnection',
  alignment: 'left',
};

const cableBlowingDateColumn: FlexibleColumn = {
  id: 'cableBlowingDate',
  header: 'ordersOverview.tableHeaders.cableBlowingDate',
  alignment: 'left',
};

const splicingAndMeasuringDateColumn: FlexibleColumn = {
  id: 'splicingAndMeasuringDate',
  header: 'ordersOverview.tableHeaders.splicingAndMeasuringDate',
  alignment: 'left',
};

const commissioningDateColumn: FlexibleColumn = {
  id: 'commissioningDate',
  header: 'ordersOverview.tableHeaders.commissioningDate',
  alignment: 'left',
};

const macAddressColumn: FlexibleColumn = {
  id: 'macAddress',
  header: 'ordersOverview.tableHeaders.macAddress',
  alignment: 'left',
};

const pdfColumn: FlexibleColumn = {
  id: 'pdf',
  header: 'ordersOverview.tableHeaders.pdf',
  alignment: 'left',
};

export const baseColumns: FlexibleColumn[] = [
  addressColumn,
  statusColumn,
  plotDesignDateColumn,
  preinstallationDateColumn,
  plotExcavationDateColumn,
  ductConnectionColumn,
  cableBlowingDateColumn,
  splicingAndMeasuringDateColumn,
  commissioningDateColumn,
];

export const columnModifications: ColumnModifications = {
  domain: {
    SE: [] as ColumnModification[],
    FI: [
      { column: customerType, index: 1 },
      { column: completedDateColumn, index: 4 },
    ],
  },
  tableType: {
    SDU: [
      { column: customerNameColumn, index: 1 },
      { column: pdfColumn, index: 1 },
      { column: customerInstallationDateColumn, index: 1 },
      { column: statusDateColumn, index: 2 },
      { column: netAdminIdColumn, index: 2 },
      { column: macAddressColumn },
    ],
    MDU: [{ column: deliveryPoints, index: 1 }],
  },
};

export const mduCellTemplateIds = [
  deliveryPoints.id,
  statusColumn.id,
  plotDesignDateColumn.id,
  preinstallationDateColumn.id,
  plotExcavationDateColumn.id,
  ductConnectionColumn.id,
  cableBlowingDateColumn.id,
  splicingAndMeasuringDateColumn.id,
  commissioningDateColumn.id,
] as const;

type MduCellTemplateKey = (typeof mduCellTemplateIds)[number];

export type MduCellTemplateMap = Record<MduCellTemplateKey, TemplateRef<any>>;
